module.exports = __webpack_public_path__ + "img/10786@3x.fee94423.png";